import { Subscription } from 'rxjs';
import { STATUS_CODE } from '@app/shared/constants/app.const';
import { ResponseModel } from '@app/shared/models/commons/response.model';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { Router } from '@angular/router'
import { StateServices } from '../../../../services/state.services'
import { SharedServices } from '../../../../services/shared.services'
import { ordinalSuffixOf } from '../../../../../helper/common'
import * as moment from 'moment'
import { MatrixServices } from '../../../../services/image/matrix.services'
import { PagingModel } from '@models/commons/paging.model'
import { AlignerService } from '@app/services/aligner.service'
import { AppUtilService } from '@app/shared/utils/app-util.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PagingResultModel } from '@app/shared/models/commons/paging-result.model';

@Component({
    selector: 'app-aligner',
    templateUrl: './aligner.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/ui-schema-table-form.component.css',
        './aligner.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class AlignerComponent implements OnInit, OnDestroy {
    list: any
    en = {}
    showEN = true

    arrIdClickedTabs: any[] = []
    jsonDataSave: any = {}
    listAligner: any[] = []
    clientAlignerForm: any[] = []
    arrayAlignerTabs: any[] = []

    idSearchDefault: any
    arrDataClickedTabs: any[] = []

    getDataSearch: any

    listHeader: any[] = []

    updateAligner: any

    idUpdate: any
    enableBehavior: any = 'false'

    oldArrImageHash: any
    oldArrRotate: any
    oldArrStyleImage: any
    oldArrFlip: any
    oldDxdyMatrixCanvas: any
    resetValue

    oldArrImage
    refreshAligner

    total: number = 0
    paging: PagingModel

    isChangeSortValue: boolean = false
    sortValue: number = 1
    sortColumn: string = ''
    sortData: any = {
        sortField: 'updateTime',
        sortType: -1
    }
    searchCondition: any = {}
    isChangeSortColumn: number = 1
    isSearching: boolean = false
    isLoading: boolean = false
    colorLoading: any = ''

    cancelSearchAligner: Subscription = null
    pageName: string = ''

    constructor(private authData: AuthService,
        private router: Router,
        private restApi: RestServices,
        private stateServices: StateServices,
        private _sharedService: SharedServices,
        private matrixServices: MatrixServices,
        private alignerService: AlignerService,
        private appUtilService: AppUtilService
    ) {
        console.clear()
        this.pageName = this.stateServices.UseSearchPageList.ALIGNER_CLINIC.pageName
    }

    ngOnInit() {
        this.colorLoading = localStorage.getItem('classThemeBody')
        this.stateServices.emitChangeHash(null)
        this.stateServices.resetData()
        this.matrixServices.resetMatrix()
        // const html = document.querySelector('ons-page');
        // html.classList.add('page-top');
        this.stateServices.emitChangeTabName('formSetting')
        this.stateServices.emitChangeViewAligner('searchData')
        this.listAligner = []
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        this.getCachedSearchDataIfExist()

        const emit: any = {}
        emit['status'] = 'hide'
        emit['view'] = 'aligner-create'
        this._sharedService.emitChangeIsShowConfirm(emit)
        this.callApiSetting()
        this.getElementUpdate()
        this.resetValueMatrix()
        this.refresh()
        this.initPagingData()
    }

    initPagingData(): void {
        this.paging = {
            pageIndex: 0,
            pageSize: 30
        }
    }

    ngOnDestroy() {
        if (this.updateAligner)
            this.updateAligner.unsubscribe()
        if (this.resetValue)
            this.resetValue.unsubscribe()
        if (this.refreshAligner)
            this.refreshAligner.unsubscribe()
        // const html = document.querySelector('ons-page');
        // html.classList.remove('page-top');

        if (this.cancelSearchAligner) {
            this.cancelSearchAligner.unsubscribe()
        }
    }

    refresh() {
        this.refreshAligner = this.stateServices.changeEmittedRefreshAligner$.subscribe(res => {
            if (res) {
                this.searchAligner()
                this.stateServices.emitChangeRefreshAligner(null)
            }
        })
    }

    @HostListener('window:scroll', ['$event'])
    onScroll() {
        if ((this.total <= (this.paging.pageIndex + 1) * this.paging.pageSize)) {
            return;
        }
        ++this.paging.pageIndex
        this.searchAligner()

        $('.page-top').find('.ng-scrollbar').removeClass('-vertical')
    }

    resetValueMatrix() {
        this.resetValue = this.stateServices.changeEmittedResetValueMatrix$.subscribe(res => {
            if (res) {
                this.matrixServices.arrImageHash = this.oldArrImageHash
                this.matrixServices.arrFlip = this.oldArrFlip
                this.matrixServices.arrImage = this.oldArrImage
                this.matrixServices.arrRotate = this.oldArrRotate
                this.matrixServices.arrStyleImage = this.oldArrStyleImage
                this.matrixServices.dXdYMatrixCanvas = this.oldDxdyMatrixCanvas
                this.stateServices.emitChangeResetValueMatrix(null)
            }
        })
    }

    getElementUpdate() {
        this.updateAligner = this.stateServices.changeEmittedUpdateAligner$.subscribe(res => {
            if (res && res['update']) {
                const update = res['update']
                update['_id'] = this.idUpdate
                const findIndex = this.listAligner.findIndex(el => {
                    return el['_id'] == this.idUpdate
                })
                if (findIndex != -1) {
                    this.listAligner[findIndex] = update
                    this.stateServices.emitChangeUpdateAligner(null)
                }
            }
        })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    callApiSetting() {
        const resourceUrl = 'resource'
        const paths = {}
        paths['{}'] = true
        const resourceData = {
            actions: [],
            status: {
                setting: {
                    map: {
                        common: true
                    },
                    paths: {
                        '{}': true
                    }
                }
            }
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const user = success['user']
                    this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                    const emitSakura = {}
                    emitSakura['enableBehavior'] = this.enableBehavior
                    this.stateServices.emitChangeEnableBehavior(emitSakura)
                    const arraySettingAll: any[] = success['response']['setting']['paths']['{}']
                    const arraySettingOption = arraySettingAll.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (arraySettingOption) {
                        this.clientAlignerForm = arraySettingOption['clientAlignerForm'] ? arraySettingOption['clientAlignerForm']['properties'] : []
                        // this.idSearchDefault = this.clientAlignerForm[0]['propertyName'];
                        this.idSearchDefault = ''
                    } else {
                        this.clientAlignerForm = []
                        this.idSearchDefault = ''
                    }
                    if (this.enableBehavior == 'true') {
                        if (this.arrayAlignerTabs.length === 0) {
                            this.arrayAlignerTabs = this.clientAlignerForm.filter(el => {
                                return el['isCondition'] == true
                            })
                        }
                        this.listHeader = this.clientAlignerForm.filter(el => {
                            return (el['type'] == 'normal' || !el['type']) && el['isListField'] == true
                        })
                    } else {
                        this.arrayAlignerTabs = []
                        this.listHeader = []
                    }

                    this.arrayAlignerTabs.forEach((el, i) => {
                        const checkInArr = this.arrIdClickedTabs.indexOf(el['propertyName'])
                        if (checkInArr != -1) {
                            this.arrDataClickedTabs.push(el)
                        }
                    })
                    if (this.enableBehavior == 'true') {
                        const cachedSearchData = this.stateServices.getSearchTabIdsByPageNameUse(this.pageName)
                        if (!cachedSearchData) {
                            this.searchAligner()
                        }
                    } else {
                        this.listAligner = []
                    }

                    $('.page-top').find('.ng-scrollbar').removeClass('-vertical')

                    const emitListSetting: any = {}
                    emitListSetting['listSettingAligner'] = this.arrayAlignerTabs
                    this.stateServices.emitChangeListSettingTabs(emitListSetting)
                },
            )
        })
    }

    functionEmitDataSearch(dataSearch: any) {
        this.initPagingData()
        this.listAligner = []
        const paths: any = {}
        paths['{}'] = true
        const end = '}'
        let strkeySearch = ''
        this.arrIdClickedTabs = dataSearch['arrIdClickedTabs']
        this.jsonDataSave = dataSearch['jsonDataSearch']

        if (this.arrIdClickedTabs && this.jsonDataSave) {
            this.stateServices.emitChangeSearchTabIdsByPageNameUse(this.pageName, {
                arrIdClickedTabs: this.arrIdClickedTabs,
                arrayAlignerTabs: this.arrayAlignerTabs,
                jsonDataSearch: this.jsonDataSave
            })

            if (this.arrIdClickedTabs.length == 0) {
                if (this.idSearchDefault && this.idSearchDefault != '') {
                    strkeySearch = this.initKeySearch(this.idSearchDefault, 0)
                } else {
                    strkeySearch = '{'
                }
            } else {
                if (this.idSearchDefault && this.idSearchDefault != '') {
                    strkeySearch = this.initKeySearch(this.idSearchDefault, 0)
                } else {
                    strkeySearch = '{'
                }
                this.arrIdClickedTabs.forEach((el, i) => {
                    if (el != this.idSearchDefault) {
                        strkeySearch += this.initKeySearch(el, i)
                    }
                })
            }
            strkeySearch += end
        } else {
            if (this.idSearchDefault && this.idSearchDefault != '') {
                strkeySearch = this.initKeySearch(this.idSearchDefault, 0)
            } else {
                strkeySearch = '{'
            }
            strkeySearch += end
        }
        this.searchCondition = JSON.parse(strkeySearch)
        const params = this.initResourceParam(this.searchCondition)
        this.loadDatasource(params)
    }

    initKeySearch(key: any, index) {
        const findItem = this.arrayAlignerTabs.find(el => {
            return el['propertyName'] == key
        })
        let strkeySearch = ''
        let dataKey = []
        if (this.jsonDataSave[key]) {
            if (typeof this.jsonDataSave[key] == 'object') {
                if (Array.isArray(this.jsonDataSave[key])) {
                    if (this.jsonDataSave[key].length > 0) {
                        let tmpContent = ''
                        this.jsonDataSave[key].forEach((item, i) => {
                            // if (i == 0) {
                            //     tmpContent += `"${item}"`;
                            // } else {
                            //     tmpContent += `,"${item}"`;
                            // }
                            if (i == 0) {
                                tmpContent = '{"' + key + '": { "$all": ["' + item + '"]}}'
                            } else {
                                tmpContent += ',{"' + key + '": { "$all": ["' + item + '"]}}'
                            }
                        })
                        if (key != this.idSearchDefault) {
                            // if (index == 0) {
                            //     strkeySearch = `"${key}":[${tmpContent}]`;
                            // } else {
                            //     strkeySearch = `,"${key}":[${tmpContent}]`;
                            // }
                            if (index == 0) {
                                strkeySearch += '"$or": [' + tmpContent + ']'
                            } else {
                                strkeySearch += ',"$and" : [ {"$or": [' + tmpContent + ']}]'
                            }
                        } else {
                            strkeySearch = `{"${key}":[${tmpContent}]`
                        }
                    } else {
                        if (key != this.idSearchDefault) {
                            // if (index == 0) {
                            //     strkeySearch = `"${key}":null`;
                            // } else {
                            //     strkeySearch = `,"${key}":null`;
                            // }
                            if(findItem['schema']['options']){
                                findItem['schema']['options'].forEach(element => {
                                    dataKey.push(element['_id'])
                                });
                                let tmpContent = ''
                                dataKey.forEach((item, i) => {
                                    if (i == 0) {
                                        tmpContent = '{"' + key + '": { "$all": ["' + item + '"]}}'
                                    } else {
                                        tmpContent += ',{"' + key + '": { "$all": ["' + item + '"]}}'
                                    }
                                })
                                if (key != this.idSearchDefault) {
                                    if (index == 0) {
                                        strkeySearch += '"$or": [' + tmpContent + ']'
                                    } else {
                                        strkeySearch += ',"$and" : [ {"$or": [' + tmpContent + ']}]'
                                    }
                                } else {
                                    strkeySearch = `{"${key}":[${tmpContent}]`
                                }
                            }
                            else{
                                if (index == 0) {
                                    strkeySearch += '"$or":[{"' + key + '":null}, { "' + key + '":[]}]'
                                } else {
                                    strkeySearch += ',"$and" : [ {"$or":[{"' + key + '":null}, { "' + key + '":[]}] }]'
                                }
                            }
                        } else {
                            strkeySearch = `{"${key}":null`
                        }
                    }
                } else {
                    const contentKeys = JSON.stringify(this.jsonDataSave[key])
                    if (key != this.idSearchDefault) {
                        if (index == 0) {
                            strkeySearch = `"${key}":${contentKeys}`
                        } else {
                            strkeySearch = `,"${key}":${contentKeys}`
                        }
                    } else {
                        strkeySearch = `{"${key}":${contentKeys}`
                    }
                }
            } else if (typeof this.jsonDataSave[key] == 'number') {
                const searchDate = moment(this.jsonDataSave[key]).utc().startOf('day').valueOf()
                if (key != this.idSearchDefault) {
                    if (index == 0) {
                        strkeySearch = `"${key}":${searchDate}`
                    } else {
                        strkeySearch = `,"${key}":${searchDate}`
                    }
                } else {
                    strkeySearch = `{"${key}":${searchDate}`
                }
            } else {
                const tmpTrim = '' + this.jsonDataSave[key]
                if (key != this.idSearchDefault) {
                    if (!tmpTrim || tmpTrim == '') {
                        if (index == 0) {
                            strkeySearch = `"${key}":null`
                        } else {
                            strkeySearch = `,"${key}":null`
                        }
                    } else {
                        if (findItem && findItem['schema'] && findItem['schema']['uiType'] == 'button') {
                            if (index == 0) {
                                strkeySearch = `"${key}":"${tmpTrim.trim()}"`
                            } else {
                                strkeySearch = `,"${key}":"${tmpTrim.trim()}"`
                            }
                        } else {
                            if (index == 0) {
                                strkeySearch = `"${key}":{"_$regex":"${tmpTrim.trim()}"}`
                            } else {
                                strkeySearch = `,"${key}":{"_$regex":"${tmpTrim.trim()}"}`
                            }
                        }
                    }
                } else {
                    if (!tmpTrim || tmpTrim == '') {
                        strkeySearch = `{"${key}":{"_$ne":null}`
                    } else {
                        strkeySearch = `{"${key}":{"_$regex":"${tmpTrim.trim()}"}`
                    }
                }
            }
        } else {
            if (key != this.idSearchDefault) {
                // if (index == 0) {
                //     strkeySearch = `"${key}":null`;
                // } else {
                //     strkeySearch = `,"${key}":null`;
                // }
                let obj = this.arrayAlignerTabs.find(o => o.propertyName === key)
                let typeinput = obj['schema']['type']
                if (typeinput == 'array') {
                    if (index == 0) {
                        strkeySearch += '"$or":[{"' + key + '":null}, { "' + key + '":[]}]'
                    } else {
                        strkeySearch += ',"$and" : [ {"$or":[{"' + key + '":null}, { "' + key + '":[]}]} ]'
                    }
                } else {
                    if (index == 0) {
                        strkeySearch += '"' + key + '":null'
                    } else {
                        strkeySearch += ',"' + key + '":null'
                    }
                }
            } else {
                strkeySearch = `{"${key}":{"_$ne":null}`
            }
            // const findItem = this.clientAlignerForm.find(item => {
            //     return item['propertyName'] == key;
            // });
            // if (findItem && findItem['schema'] && findItem['schema']['uiConditionType'] == 'partial') {
            //     if (key != this.idSearchDefault) {
            //         strkeySearch = `,"${key}":null`;
            //     } else {
            //         strkeySearch = `{"${key}":{"_$ne":null}`;
            //     }
            // } else {
            //     if (key != this.idSearchDefault) {
            //         strkeySearch = `,"${key}":null`;
            //     } else {
            //         strkeySearch = `{"${key}":{"_$ne":null}`;
            //     }
            // }
        }
        return strkeySearch
    }

    searchAligner() {
        const params = this.initResourceParam(this.searchCondition)
        this.loadDatasource(params)
    }

    loadDatasource(params: any): void {
        this.isSearching = true;
        this.isLoading = true;
        this.authData.authToken().then(tokenReNew => {
            if (this.cancelSearchAligner) {
                this.cancelSearchAligner.unsubscribe()
            }
            this.cancelSearchAligner = this.alignerService.search(params, tokenReNew).subscribe((res: ResponseModel<PagingResultModel<any>>) => {
                if (res.error_code === STATUS_CODE.SUCCESS) {
                    this.loadClinicAlignerDataSucess(res.data)
                } else {
                    this.appUtilService.developerErrorHandle(res)
                }
                this.resetFlag()
            }, (errors: HttpErrorResponse) => {
                this.appUtilService.systemErrorHandle(errors)
                this.resetFlag()
            })
        }, (errors: HttpErrorResponse) => {
            this.appUtilService.systemErrorHandle(errors)
            this.resetFlag()
        })
    }

    resetFlag() {
        this.isSearching = false;
        this.isLoading = false;
        this.isChangeSortValue = false;
    }

    initResourceParam(searches): any {
        const resourceParam = {
            condition: searches,
            page: {
                offset: this.paging.pageIndex * this.paging.pageSize,
                limit: this.paging.pageSize
            },
            sort: this.sortData
        }
        return resourceParam
    }

    loadClinicAlignerDataSucess(data: PagingResultModel<any>): void {
        if (this.isChangeSortValue) {
            this.isChangeSortValue = false
            this.listAligner = []
        }
        const listAligner = data.datasource
        this.listAligner = this.listAligner.concat(listAligner)
        $('.page-top').find('.ng-scrollbar').removeClass('-vertical')
        this.total = data.total || 0
    }

    showOptionsString(stringInput: string) {
        let returnString = ''
        if (stringInput && stringInput != '') {
            if (stringInput.length > 100) {
                returnString = stringInput.substring(0, 100) + '...'
            } else {
                returnString = stringInput
            }
        }
        return returnString
    }

    selectClientDetail(id) {
        this.router.navigateByUrl('/app/main/client/edit/' + id + '/home')
        this._sharedService.getIdParam(id)
        // this._sharedService.getlisIfSearch(this.arrayKeySearchValuesChangeForUser);
    }

    editAligner(item) {
        let  clientDetail = item.clientInfo
        this.idUpdate = item['_id']
        const totalNumber = item['totalNumber']
        if (this.listAligner) {
            this.stateServices.emitChangeViewAligner('renderData')
            const stageActive = totalNumber && totalNumber > 0 ? true : false
            this.oldArrImageHash = jQuery.extend(true, [], this.matrixServices.arrImageHash)
            this.oldArrRotate = jQuery.extend(true, [], this.matrixServices.arrRotate)
            this.oldArrStyleImage = jQuery.extend(true, [], this.matrixServices.arrStyleImage)
            this.oldArrFlip = jQuery.extend(true, [], this.matrixServices.arrFlip)
            this.oldDxdyMatrixCanvas = jQuery.extend(true, [], this.matrixServices.dXdYMatrixCanvas)
            this.oldArrImage = jQuery.extend(true, [], this.matrixServices.arrImage)
            this.matrixServices.resetMatrix()
            const arrAligner = {
                'action': 'editAligner',
                'clientId': item['clientId'],
                'alignerId': item['_id'],
                'clientDetail': clientDetail,
                'activeAligner': item,
                'stageActive': stageActive,
            }
            this._sharedService.emitChange(arrAligner)
        }
    }

    getWayAppear(propertyName, item) {
        const returnArray = 'array'
        const returnSelectString = 'stringSelect'
        const returnJson = 'json'
        const returnString = 'string'
        const returnDate = 'date'

        if (typeof item == 'object') {
            if (Array.isArray(item)) {
                return returnArray
            }
            return returnJson
        } else if (typeof item == 'number') {
            return returnDate
        } else {
            const findItem = this.clientAlignerForm.find(el => {
                return el['propertyName'] == propertyName
            })
            if (findItem) {
                if (findItem['schema'] && findItem['schema']['uiType'] == 'button') {
                    return returnSelectString
                }
            }
        }
        return returnString
    }

    showOptionSelect(optionId, propertyName) {
        const findItem = this.clientAlignerForm.find(el => {
            return el['propertyName'] == propertyName
        })
        if (findItem) {
            const listOptions = findItem['schema']['options']
            const result = listOptions.find(el => {
                return el['_id'] == optionId
            })
            if (result) {
                return result['title']
            }
            return ''
        }
        return ''
    }

    showDate(datesString) {
        const initDate: Date = new Date(datesString)
        const year = initDate.getFullYear()
        const month = ((initDate.getMonth() + 1) < 10) ? ('0' + (initDate.getMonth() + 1)) : (initDate.getMonth() + 1)
        const date = (initDate.getDate() < 10) ? ('0' + initDate.getDate()) : initDate.getDate()
        return year + '.' + month + '.' + date
    }

    showNameClient(client) {
        let showName = ''
        if (client) {
            if (client['firstName']) {
                showName += client['firstName'] + ' '
            }
            if (client['familyName']) {
                showName += client['familyName']
            }
        }
        return showName
    }

    showName(item) {
        const title = item['title'] ? item['title'] : ''
        const phase = item['phase'] ? ordinalSuffixOf(item['phase']) : ''
        return phase + ' ' + title
    }

    sortAlignerDatasource(sortColumn: string): void {
        if (this.sortColumn != sortColumn) {
            this.sortValue = 1
        }
        switch (this.sortValue) {
            case 1: {
                this.sortValue = -1
                break
            }
            case -1: {
                this.sortValue = 1
                break
            }
        }
        this.isChangeSortValue = true
        this.listAligner = [];
        this.paging.pageIndex = 0
        this.sortColumn = sortColumn

        this.sortData = {
            sortField: this.sortColumn,
            sortType: this.sortValue
        }

        this.searchAligner()
        // Host fix: Sometimes when sort data of table => scroll event is not trigger
        this.isChangeSortColumn = null
        setTimeout(() => {
            this.isChangeSortColumn = (new Date()).getTime()
        }, 0);
    }

    private getCachedSearchDataIfExist() {
        const cachedSearchData = this.stateServices.getSearchTabIdsByPageNameUse(this.pageName)
        if (cachedSearchData) {
            if (cachedSearchData.arrIdClickedTabs) {
                this.arrIdClickedTabs = cachedSearchData.arrIdClickedTabs
            }

            if (cachedSearchData.arrayAlignerTabs) {
                this.arrayAlignerTabs = cachedSearchData.arrayAlignerTabs
            }

            if (cachedSearchData.jsonDataSearch) {
                this.jsonDataSave = cachedSearchData.jsonDataSearch
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/status/aligner/aligner.component.ts